import { isSafeInAppPath } from '@utils/safePath';

/**
 * Check if a returnTo value is a safe relative path.
 * Returns the path if valid, or null if invalid/missing.
 */
export function validateReturnTo(returnTo: string | null | undefined): string | null {
  return isSafeInAppPath(returnTo) ? returnTo : null;
}
